import { db } from "../../../mp-database"
import getTruthyKeys from "../getTruthyKeys"
import parseSnapshot from "../parseSnapshot"
import { values } from "mout/object"

export default async function markGroupCPsNeedingUpdate(
  student,
  record,
  courseId,
  schoolYear
) {
  if (!student) return Promise.reject()

  function findTeachersWithClasses(educatorsSnapshot, classes) {
    let teachersWithClasses = {}
    const educators = values(parseSnapshot(educatorsSnapshot))
    educators.forEach(educator => {
      if (!educator.classes) return
      classes.forEach(cl => {
        if (educator.classes[cl]) {
          teachersWithClasses[educator.id] = true
        }
      })
    })
    return teachersWithClasses
  }

  const classes = getTruthyKeys(student.classes)
  //if the current class is not in student's classes object, then its added to classes array
  //To change the updated status in GUA
  if (record && !classes.includes(record.id)) {
    classes.push(record.id)
  }
  const educatorsSnapshot = await db
    .collection("educators")
    .where("school", "==", student.school)
    .get()

  const teachers = Object.keys(
    findTeachersWithClasses(educatorsSnapshot, classes)
  )
  const groupCPIds = [
    `SCHOOL DISTRICT_${student.schoolDistrict}_${courseId}_${schoolYear}`,
    `SCHOOL_${student.school}_${courseId}_${schoolYear}`,
    ...classes.map(classId => `CLASS_${classId}_${courseId}_${schoolYear}`),
    ...teachers.map(
      teacherId => `TEACHER_${teacherId}_${courseId}_${schoolYear}`
    )
  ]

  return new Promise(async (resolve, reject) => {
    const batch = db.batch()
    for (let i = 0; i < groupCPIds.length; i++) {
      let ref = db.collection("courses_groups").doc(groupCPIds[i])
      await ref.get().then(snapshot => {
        if (snapshot.exists && snapshot.data().updated) {
          batch.update(ref, {
            [`updated`]: false
          })
        }
      })
    }
    resolve(batch.commit())
  })
}
